import {
  Accordion,
  AccordionDetails,

  // Checkbox,
  // FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { PmiButton } from 'shell/components/shared/button';
import { useState } from 'react';
import { FormikProps } from 'formik';
import { FiltersFormInstitution } from 'system/pages/institution/list/types';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersInstitutionProps {
  filterServiceForm: FormikProps<FiltersFormInstitution>;
}

const FiltersInstitution = ({ filterServiceForm }: FiltersInstitutionProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-institution-content"
        id="panel-institution-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterServiceForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterServiceForm.values.code}
                onChange={filterServiceForm.handleChange}
                error={filterServiceForm.touched.code && Boolean(filterServiceForm.errors.code)}
                helperText={filterServiceForm.errors.code}
                inputProps={{
                  maxLength: 2,
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione"
                label="Descrizione"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterServiceForm.values.description}
                onChange={filterServiceForm.handleChange}
                error={
                  filterServiceForm.touched.description &&
                  Boolean(filterServiceForm.errors.description)
                }
                helperText={filterServiceForm.errors.description}
                inputProps={{
                  maxLength: 40,
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Istat"
                label="ISTAT"
                id="istat"
                name="istat"
                fullWidth
                inputProps={{
                  maxLength: 6,
                  pattern: '[0-9]*',
                }}
                type="text"
                variant="outlined"
                value={filterServiceForm.values.istat}
                onChange={(event) =>
                  filterServiceForm.setFieldValue(
                    'istat',
                    event.target.validity.valid
                      ? event.target.value
                      : filterServiceForm.values.istat
                  )
                }
                error={filterServiceForm.touched.istat && Boolean(filterServiceForm.errors.istat)}
                helperText={filterServiceForm.errors.istat}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Provincia"
                label="Provincia"
                id="province"
                name="province"
                fullWidth
                type="text"
                variant="outlined"
                value={filterServiceForm.values.province}
                onChange={filterServiceForm.handleChange}
                inputProps={{
                  maxLength: 2,
                }}
                error={
                  filterServiceForm.touched.province && Boolean(filterServiceForm.errors.province)
                }
                helperText={filterServiceForm.errors.province}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="numero ufficio"
                label="N .uff. StCiv"
                id="officeNumber"
                name="officeNumber"
                fullWidth
                type="number"
                variant="outlined"
                value={filterServiceForm.values.officeNumber}
                onChange={(event) =>
                  filterServiceForm.setFieldValue(
                    'officeNumber',
                    event.target.validity.valid
                      ? parseInt(event.target.value, 10) || undefined
                      : filterServiceForm.values.officeNumber
                  )
                }
                inputProps={{
                  min: '1',
                  step: '1',
                  pattern: '[0-9]*',
                }}
                error={
                  filterServiceForm.touched.officeNumber &&
                  Boolean(filterServiceForm.errors.officeNumber)
                }
                helperText={filterServiceForm.errors.officeNumber}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              {/* <FormControlLabel
                control={
                  <Checkbox
                    id="anpr"
                    name="anpr"
                    checked={filterServiceForm.values.anpr}
                    onChange={filterServiceForm.handleChange}
                    inputProps={{ 'aria-label': 'Checkbox ANPR' }}
                  />
                }
                label="ANPR"
              /> */}
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterServiceForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersInstitution.displayName = 'Filters Institution component';

export default FiltersInstitution;
